// extracted by mini-css-extract-plugin
export var arrow = "ProofCards-module--arrow--04922";
export var card = "ProofCards-module--card--5178c";
export var cardLink = "ProofCards-module--cardLink--0afd0";
export var category = "ProofCards-module--category--29ff1";
export var footer = "ProofCards-module--footer--ebf0e";
export var grid = "ProofCards-module--grid--e3139";
export var heading = "ProofCards-module--heading--fdc77";